import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

import Footer from '../Materials/Footer';
import BurgerBar2 from '../Materials/BurgerBar2';
import { useAuth } from '../../context/AuthContext';

import CreateIdeaWindow from '../CreateIdeaWindow';
import EditIcon from '@mui/icons-material/Edit';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function DashboardPage() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const navigate = useNavigate();
  const [advices, setAdvices] = React.useState([]);
  const [futureAdvices, setFutureAdvices] = React.useState([]);
  const [events, setEvents] = React.useState([]);
  const [futureEvents, setFutureEvents] = React.useState([]);
  const [myIdeasCount, setMyIdeasCount] = useState(0);
  const [receivedIdeasCount, setReceivedIdeasCount] = useState(0);
  const [sharedIdeasCount, setSharedIdeasCount] = useState(0);
  const [coauthoredIdeasCount, setCoauthoredIdeasCount] = useState(0);
  const [averageRating, setAverageRating] = useState(0);
  const { user } = useAuth();
  const { isAdmin, isManager } = useAuth();
  const isAdminOrManager = isAdmin() || isManager();
  const [createIdeaModalOpen, setCreateIdeaModalOpen] = useState(false);
  const [ideaWindowOpen, setIdeaWindowOpen] = useState(false);
  const [selectedPosts, setSelectedPosts] = useState([]);

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const [regulatoryDoc, setRegulatoryDoc] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [file, setFile] = useState(null);
  const [openRegulatoryModal, setOpenRegulatoryModal] = useState(false);


  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

  const handleCreateIdea = async (ideaData) => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/ideas', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ideaData),
      });

      if (response.ok) {
        showNotification('Idea created successfully!', 'success');
      } else {
        showNotification('Failed to create idea', 'error');
      }
    } catch (error) {
      console.error("Error:", error);
      showNotification('An error occurred', 'error');
    }
  };



  useEffect(() => {
    const fetchIdeaCounts = async () => {
      try {
        if (!user?.userId) return;

        
        const myIdeasResponse = await fetch(`https://api.hub4food.colab4food.com/api/ideas/user/${user.userId}`);
        if (myIdeasResponse.ok) {
          const myIdeas = await myIdeasResponse.json();
          setMyIdeasCount(myIdeas.length);

          
          const sharedByUserIdeas = myIdeas.filter(idea => idea.is_shared === true);
          setSharedIdeasCount(sharedByUserIdeas.length);

       
          if (myIdeas.length > 0) {
            const totalRating = myIdeas.reduce((sum, idea) => sum + (idea.rating || 0), 0);
            const avgRating = totalRating / myIdeas.length;
            setAverageRating(Number(avgRating.toFixed(1)));
          } else {
            setAverageRating(0);
          }
        }

        // Buscar ideias recebidas
        const receivedResponse = await fetch(`https://api.hub4food.colab4food.com/api/user_idea/user/${user.userId}`);
        if (receivedResponse.ok) {
          const receivedIdeas = await receivedResponse.json();
          setReceivedIdeasCount(receivedIdeas.length);
        }

        // Buscar todas as ideias para verificar coautoria
        const allIdeasResponse = await fetch(`https://api.hub4food.colab4food.com/api/ideas`);
        if (allIdeasResponse.ok) {
          const allIdeas = await allIdeasResponse.json();

          const coauthoredIdeas = allIdeas.filter(idea =>
            Array.isArray(idea.co_authors) && idea.co_authors.includes(user.userId)
          );

          setCoauthoredIdeasCount(coauthoredIdeas.length);
        }

      } catch (error) {
        console.error("Error fetching idea counts:", error);
      }
    };

    fetchIdeaCounts();
  }, [user?.userId]);


  // Buscar advices da API ao carregar o componente
  React.useEffect(() => {
    const fetchAdvices = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/advices');
        if (response.ok) {
          const data = await response.json();
          const today = new Date();

          // Filtrar apenas datas futuras
          const future = data.filter(advice =>
            new Date(advice.submission_period) > today
          );

          // Ordenar por data mais próxima
          future.sort((a, b) =>
            new Date(a.submission_period) - new Date(b.submission_period)
          );

          setFutureAdvices(future.slice(0, 2));
        }
      } catch (error) {
        console.error("Error fetching advices:", error);
      }
    };

    fetchAdvices();
  }, []);


// Buscar posts selecionados do LinkedIn
React.useEffect(() => {
  const fetchSelectedPosts = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/linkedin-posts/selected');
      if (response.ok) {
        const data = await response.json();
        setSelectedPosts(data);
      }
    } catch (error) {
      console.error("Error fetching selected posts:", error);
    }
  };

  fetchSelectedPosts();
}, []);

  // Função para formatar a data (dia e mês abreviado)
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const month = monthNames[date.getMonth()];
    return { day, month };
  };

  // Atualize o useEffect existente para eventos
  React.useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/events');
        if (response.ok) {
          const data = await response.json();
          const today = new Date();

          // Filtrar apenas eventos futuros
          const future = data.filter(event =>
            new Date(event.initial_date) > today
          );

          // Ordenar por data mais próxima
          future.sort((a, b) =>
            new Date(a.initial_date) - new Date(b.initial_date)
          );

          setFutureEvents(future.slice(0, 2));
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
  const fetchRegulatoryDoc = async () => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/regulatory-documents?year=${selectedYear}&month=${selectedMonth}`);
      if (response.ok) {
        const data = await response.json();
        setRegulatoryDoc(data || null);
      } else {
        setRegulatoryDoc(null);
      }
    } catch (error) {
      console.error("Error fetching regulatory document:", error);
    }
  };

  fetchRegulatoryDoc();
}, [selectedMonth, selectedYear]);

const handlePreviousMonth = () => {
  if (selectedMonth === 1) {
    setSelectedMonth(12);
    setSelectedYear(selectedYear - 1);
  } else {
    setSelectedMonth(selectedMonth - 1);
  }
};

const handleNextMonth = () => {
  if (selectedMonth === 12) {
    setSelectedMonth(1);
    setSelectedYear(selectedYear + 1);
  } else {
    setSelectedMonth(selectedMonth + 1);
  }
};

const handleUpload = async () => {
  if (!file) {
    alert("Please select a file first.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", selectedMonth);
  formData.append("year", selectedYear);

  try {
    const response = await fetch("https://api.hub4food.colab4food.com/api/regulatory-documents/upload", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      alert("File uploaded successfully!");
      setFile(null);
      setOpenRegulatoryModal(false);
      const data = await response.json();
      setRegulatoryDoc(data);
    } else {
      alert("Failed to upload file.");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("An error occurred while uploading.");
  }
};


  

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Navbar */}
      <BurgerBar2 />

      {/* Main Content - Dashboard */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h4" gutterBottom>
            HubControl Panel
          </Typography>
          <Grid container spacing={4}>
            {/* First Column: Calls Section */}
            <Grid item xs={12} md={4}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Box sx={{
                    p: 2,
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#f9f9f9',
                    height: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="h6">Calls</Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#3FA5D4',
                            cursor: 'pointer',
                            '&:hover': { textDecoration: 'underline' }
                          }}
                          onClick={() => navigate('/advices')}
                        >
                          View Calls
                        </Typography>
                        {isAdminOrManager && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#3FA5D4',
                              cursor: 'pointer',
                              '&:hover': { textDecoration: 'underline' }
                            }}
                            onClick={() => navigate('/createAdvices')}
                          >
                            Create Call
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {/* First Call */}
                    {futureAdvices.length > 0 && (
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{
                          backgroundColor: '#3FA5D4',
                          color: 'white',
                          borderRadius: '4px',
                          textAlign: 'center',
                          padding: '4px',
                          minWidth: '40px',
                          marginRight: '12px'
                        }}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formatDate(futureAdvices[0].submission_period).day}
                          </Typography>
                          <Typography variant="caption">
                            {formatDate(futureAdvices[0].submission_period).month}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'normal', mt: -0.8 }}>
                            {futureAdvices[0].title}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'gray' }}>
                            {new Date(futureAdvices[0].submission_period).toLocaleDateString('en-US', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {/* Second Call */}
                    {futureAdvices.length > 1 && (
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{
                          backgroundColor: '#3FA5D4',
                          color: 'white',
                          borderRadius: '4px',
                          textAlign: 'center',
                          padding: '4px',
                          minWidth: '40px',
                          marginRight: '12px'
                        }}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formatDate(futureAdvices[1].submission_period).day}
                          </Typography>
                          <Typography variant="caption">
                            {formatDate(futureAdvices[1].submission_period).month}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'normal', mt: -0.8 }}>
                            {futureAdvices[1].title}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'gray' }}>
                            {new Date(futureAdvices[1].submission_period).toLocaleDateString('en-US', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {futureAdvices.length === 0 && (
                      <Typography variant="body1" sx={{ color: 'gray', textAlign: 'center', py: 2 }}>
                        No upcoming calls
                      </Typography>
                    )}
                  </Box>
                </Grid>

                {/* Events Section */}
                <Grid item>
                  <Box sx={{
                    p: 2,
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#f9f9f9',
                    height: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="h6">Events</Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#3FA5D4',
                            cursor: 'pointer',
                            '&:hover': { textDecoration: 'underline' }
                          }}
                          onClick={() => navigate('/viewcalendar')}
                        >
                          More Information
                        </Typography>
                        {isAdminOrManager && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#3FA5D4',
                              cursor: 'pointer',
                              '&:hover': { textDecoration: 'underline' }
                            }}
                            onClick={() => navigate('/events')}
                          >
                            Events
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {/* First Event */}
                    {futureEvents.length > 0 && (
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{
                          backgroundColor: '#3FA5D4',
                          color: 'white',
                          borderRadius: '4px',
                          textAlign: 'center',
                          padding: '4px',
                          minWidth: '40px',
                          marginRight: '12px'
                        }}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formatDate(futureEvents[0].initial_date).day}
                          </Typography>
                          <Typography variant="caption">
                            {formatDate(futureEvents[0].initial_date).month}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'normal', mt: -0.8 }}>
                            {futureEvents[0].name}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'gray' }}>
                            {new Date(futureEvents[0].initial_date).toLocaleDateString('en-US', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {/* Second Event */}
                    {futureEvents.length > 1 && (
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{
                          backgroundColor: '#3FA5D4',
                          color: 'white',
                          borderRadius: '4px',
                          textAlign: 'center',
                          padding: '4px',
                          minWidth: '40px',
                          marginRight: '12px'
                        }}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formatDate(futureEvents[1].initial_date).day}
                          </Typography>
                          <Typography variant="caption">
                            {formatDate(futureEvents[1].initial_date).month}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'normal', mt: -0.8 }}>
                            {futureEvents[1].name}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'gray' }}>
                            {new Date(futureEvents[1].initial_date).toLocaleDateString('en-US', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {futureEvents.length === 0 && (
                      <Typography variant="body1" sx={{ color: 'gray', textAlign: 'center', py: 2 }}>
                        No upcoming events
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item>
                  <Box
                    sx={{
                      p: 2,
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: '#f9f9f9',
                      height: '100%',
                      textAlign: 'center',
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      Regulatory Insights
                    </Typography>

                    {/* Navegação de meses */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Button size="small" onClick={handlePreviousMonth}>←</Button>
                      <Typography variant="subtitle1">
                        {new Date(selectedYear, selectedMonth - 1).toLocaleString('default', { month: 'long', year: 'numeric' })}
                      </Typography>
                      <Button size="small" onClick={handleNextMonth}>→</Button>
                    </Box>

                    {/* Documento atual */}
                    {regulatoryDoc && regulatoryDoc.file_url ? (
                      <Box>
                        <a
                          href={`https://api.hub4food.colab4food.com${regulatoryDoc.file_url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#3FA5D4', textDecoration: 'none' }}
                        >
                          View Document
                        </a>
                      </Box>
                    ) : (
                      <Typography variant="body2" sx={{ color: 'gray' }}>
                        No document uploaded for this month.
                      </Typography>
                    )}

                    {/* Botão de editar */}
                    {isAdminOrManager && (
                      <Button
                        variant="outlined"
                        startIcon={<EditIcon />}
                        sx={{ mt: 2 }}
                        onClick={() => setOpenRegulatoryModal(true)}
                      >
                        Upload / Replace
                      </Button>
                    )}
                  </Box>

                  {/* Modal de upload */}
                  {openRegulatoryModal && (
                    <Box
                      sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000,
                      }}
                    >
                      <Box sx={{ backgroundColor: 'white', p: 3, borderRadius: 2, minWidth: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                          Upload Regulatory Document
                        </Typography>
                        <input
                          type="file"
                          accept=".pdf,.ppt,.pptx"
                          onChange={(e) => setFile(e.target.files[0])}
                          style={{ marginBottom: '1rem' }}
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                          <Button variant="contained" onClick={handleUpload}>
                            Save
                          </Button>
                          <Button variant="outlined" color="error" onClick={() => setOpenRegulatoryModal(false)}>
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Grid>


              </Grid>
            </Grid>

            {/* Segunda Coluna: Retângulo Grande com Notícias */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2,
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  backgroundColor: '#f9f9f9',
                  height: '100%',
                  overflowY: 'auto', 
                  maxHeight: '600px', 
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">Latest News</Typography>
                  {isManager() && ( 
                    <IconButton onClick={() => navigate('/newsManagement')}>
                      <EditIcon />
                    </IconButton>
                  )}
                </Box>

                {/* Display selected posts */}
                {selectedPosts.length > 0 ? (
                  selectedPosts.map((post) => (
                    <Box key={post.id} sx={{ mb: 3 }}>
                      <Typography variant="subtitle1" gutterBottom>
                        {post.title || 'C4F - News'}
                      </Typography>
                      <Box
                        sx={{
                          position: 'relative',
                          overflow: 'hidden',
                          width: '100%',
                          borderRadius: '4px',
                        }}
                      >
                        <iframe
                          src={post.url}
                          height="400"
                          width="100%"
                          frameBorder="0"
                          allowFullScreen=""
                          title={`LinkedIn Post ${post.id}`}
                          style={{ borderRadius: '4px' }}
                        ></iframe>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body1" sx={{ color: 'gray', textAlign: 'center', py: 2 }}>
                    No news selected
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Terceira Coluna: 3 quadrados */}
            <Grid item xs={12} md={4}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f9f9f9', height: '100%' }}>
                    <Typography variant="h6" gutterBottom>
                      Ideation Center
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                      <Button
                        variant="contained"
                        onClick={() => setIdeaWindowOpen(true)}
                        sx={{
                          backgroundColor: '#3FA5D4',
                          '&:hover': {
                            backgroundColor: '#2e8cb8',
                          },
                        }}
                      >
                        Create Idea
                      </Button>

                      <Button
                        variant="contained"
                        onClick={() => navigate('/listIdea')}
                        sx={{
                          backgroundColor: '#3FA5D4',
                          '&:hover': {
                            backgroundColor: '#2e8cb8',
                          },
                        }}
                      >
                        List Idea
                      </Button>
                    </Box>
                  </Box>
                </Grid>

                <Grid item>
                  <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f9f9f9', height: '100%' }}>
                    <Typography variant="h6" gutterBottom>
                      My Numbers
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mb: 2,
                      }}
                    >
                      <Typography variant="body1" sx={{ flex: 1, textAlign: 'center' }}>
                        {myIdeasCount}
                      </Typography>
                      <Typography variant="body1" sx={{ flex: 1, textAlign: 'center' }}>
                        {sharedIdeasCount}
                      </Typography>
                      <Typography variant="body1" sx={{ flex: 1, textAlign: 'center' }}>
                        {receivedIdeasCount}
                      </Typography>
                      <Typography variant="body1" sx={{ flex: 1, textAlign: 'center' }}>{coauthoredIdeasCount}</Typography>
                      <Typography variant="body1" sx={{ flex: 1, textAlign: 'center' }}>{averageRating}</Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1, textAlign: 'center' }}>
                        Total.
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1, textAlign: 'center' }}>
                        Share.
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1, textAlign: 'center' }}>
                        Receiv.
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1, textAlign: 'center' }}>
                        Partner.
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1, textAlign: 'center' }}>
                        Avg Rate.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item>
                  <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f9f9f9', height: '100%' }}>
                    <Typography variant="h6" gutterBottom>
                      Speedmeeting
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Button
                        variant="contained"
                        onClick={() => navigate('/createSpeedmeeting')}
                        sx={{
                          backgroundColor: '#3FA5D4',
                          '&:hover': {
                            backgroundColor: '#2e8cb8',
                          },
                        }}
                      >
                        Schedule Speedmeeting
                      </Button>
                      {isAdminOrManager && (
                        <Button
                          variant="contained"
                          onClick={() => navigate('/viewSpeedmeeting')}
                          sx={{
                            backgroundColor: '#3FA5D4',
                            '&:hover': {
                              backgroundColor: '#2e8cb8',
                            },
                          }}
                        >
                          View All Speedmeeting
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        onClick={() => navigate('/viewUserSpeedmeeting')}
                        sx={{
                          backgroundColor: '#3FA5D4',
                          '&:hover': {
                            backgroundColor: '#2e8cb8',
                          },
                        }}
                      >
                        View Speedmeeting
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Modal de criação de ideia */}
      <CreateIdeaWindow
        open={ideaWindowOpen}
        onClose={() => setIdeaWindowOpen(false)}
        onCreate={handleCreateIdea}
      />

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      <Box>
        <Footer>

        </Footer>
      </Box>
    </Box>
  );
}